export class resetPasswordModel {
  password:string;
  confirmPassword: string;
}
